import { render, staticRenderFns } from "./AcikAlimSiparisleri.vue?vue&type=template&id=8da79a4e&"
import script from "./AcikAlimSiparisleri.vue?vue&type=script&lang=js&"
export * from "./AcikAlimSiparisleri.vue?vue&type=script&lang=js&"
import style0 from "./AcikAlimSiparisleri.vue?vue&type=style&index=0&id=8da79a4e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports